var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"virtual-el-table"},[_c('el-table',_vm._g(_vm._b({ref:"table",attrs:{"data":_vm.visibleData,"height":_vm.height,"default-sort":_vm.defaultSort},on:{"sort-change":_vm.onSortChange}},'el-table',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }